module.exports = __webpack_public_path__ + "static/media/tracker-cam-ia.d2111b48.png";